// Author Liu Cui Cui
// Date 2022-08-25 18:12:08

class SithMesTpmWarningDataTwd {
    constructor({
                    id = null,
                    twdAlarmDataCategory = '',
                    twdAlarmDataClearInfo = '',
                    twdAlarmDataInstance = '',
                    twdAlarmDataPriority = '',
                    twdAlarmDataSource = '',
                    twdAlarmDataState = '',
                    twdAlarmId = '',
                    twdAlarmMessage = '',
                    twdAlarmState = '',
                    twdAlarmStartTime = '',
                    twdAlarmEndTime = '',
                    twdAlarmDuration = '',
                    twdApplicationType = '',
                    twdClientId = '',
                    twdOwnerId = '',
                    remark = ''
                }
                    = {}) {
        this.id = id;
        this.twdAlarmDataCategory = twdAlarmDataCategory;
        this.twdAlarmDataClearInfo = twdAlarmDataClearInfo;
        this.twdAlarmDataInstance = twdAlarmDataInstance;
        this.twdAlarmDataPriority = twdAlarmDataPriority;
        this.twdAlarmDataSource = twdAlarmDataSource;
        this.twdAlarmDataState = twdAlarmDataState;
        this.twdAlarmId = twdAlarmId;
        this.twdAlarmMessage = twdAlarmMessage;
        this.twdAlarmState = twdAlarmState;
        this.twdAlarmStartTime = twdAlarmStartTime;
        this.twdAlarmEndTime = twdAlarmEndTime;
        this.twdAlarmDuration = twdAlarmDuration;
        this.twdApplicationType = twdApplicationType;
        this.twdClientId = twdClientId;
        this.twdOwnerId = twdOwnerId;
        this.remark = remark;
    }
}

function newEntity() {
    return new SithMesTpmWarningDataTwd();
}

function gridFields() {
    return Object.freeze([
        {
            key: 'id',
            label: 'label.sith.tpm.sithMesTpmWarningDataTwd.grid.id',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'twdAlarmDataCategory',
            label: 'label.sith.tpm.sithMesTpmWarningDataTwd.grid.twdAlarmDataCategory',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'twdAlarmDataClearInfo',
            label: 'label.sith.tpm.sithMesTpmWarningDataTwd.grid.twdAlarmDataClearInfo',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'twdAlarmDataInstance',
            label: 'label.sith.tpm.sithMesTpmWarningDataTwd.grid.twdAlarmDataInstance',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'twdAlarmDataPriority',
            label: 'label.sith.tpm.sithMesTpmWarningDataTwd.grid.twdAlarmDataPriority',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'twdAlarmDataSource',
            label: 'label.sith.tpm.sithMesTpmWarningDataTwd.grid.twdAlarmDataSource',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'twdAlarmDataState',
            label: 'label.sith.tpm.sithMesTpmWarningDataTwd.grid.twdAlarmDataState',
            sortable: true,
            form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'twdAlarmId',
            label: 'label.sith.tpm.sithMesTpmWarningDataTwd.grid.twdAlarmId',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'twdAlarmMessage',
            label: 'label.sith.tpm.sithMesTpmWarningDataTwd.grid.twdAlarmMessage',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'twdAlarmState',
            label: 'label.sith.tpm.sithMesTpmWarningDataTwd.grid.twdAlarmState',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'twdAlarmStartTime',
            label: 'label.sith.tpm.sithMesTpmWarningDataTwd.grid.twdAlarmStartTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'twdAlarmEndTime',
            label: 'label.sith.tpm.sithMesTpmWarningDataTwd.grid.twdAlarmEndTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'twdAlarmDuration',
            label: 'label.sith.tpm.sithMesTpmWarningDataTwd.grid.twdAlarmDuration',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'twdApplicationType',
            label: 'label.sith.tpm.sithMesTpmWarningDataTwd.grid.twdApplicationType',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'twdClientId',
            label: 'label.sith.tpm.sithMesTpmWarningDataTwd.grid.twdClientId',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'twdOwnerId',
            label: 'label.sith.tpm.sithMesTpmWarningDataTwd.grid.twdOwnerId',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'remark',
            label: 'label.sith.tpm.sithMesTpmWarningDataTwd.grid.remark',
            sortable: true,
            isDetail: true,
            form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
            }
        }
    ])
}

const filter = {
    idFilter: '',
    idListFilter: [],
    twdAlarmDataCategoryFilter: '',
    twdAlarmDataClearInfoFilter: '',
    twdAlarmDataInstanceFilter: '',
    twdAlarmDataPriorityFilter: '',
    twdAlarmDataSourceFilter: '',
    twdAlarmDataStateFilter: '',
    twdAlarmIdFilter: '',
    twdAlarmMessageFilter: '',
    twdAlarmStateFilter: '',
    twdAlarmStartTimeRteFilter: '',
    twdAlarmStartTimeLteFilter: '',
    twdAlarmEndTimeRteFilter: '',
    twdAlarmEndTimeLteFilter: '',
    twdAlarmDurationFilter: '',
    twdApplicationTypeFilter: '',
    twdClientIdFilter: '',
    twdOwnerIdFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'twdAlarmDataCategoryFilter',
        label: 'label.sith.tpm.sithMesTpmWarningDataTwd.filter.twdAlarmDataCategory',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'twdAlarmDataClearInfoFilter',
        label: 'label.sith.tpm.sithMesTpmWarningDataTwd.filter.twdAlarmDataClearInfo',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'twdAlarmDataInstanceFilter',
        label: 'label.sith.tpm.sithMesTpmWarningDataTwd.filter.twdAlarmDataInstance',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'twdAlarmDataPriorityFilter',
        label: 'label.sith.tpm.sithMesTpmWarningDataTwd.filter.twdAlarmDataPriority',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'twdAlarmDataSourceFilter',
        label: 'label.sith.tpm.sithMesTpmWarningDataTwd.filter.twdAlarmDataSource',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'twdAlarmDataStateFilter',
        label: 'label.sith.tpm.sithMesTpmWarningDataTwd.filter.twdAlarmDataState',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'twdAlarmIdFilter',
        label: 'label.sith.tpm.sithMesTpmWarningDataTwd.filter.twdAlarmId',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'twdAlarmMessageFilter',
        label: 'label.sith.tpm.sithMesTpmWarningDataTwd.filter.twdAlarmMessage',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'twdAlarmStateFilter',
        label: 'label.sith.tpm.sithMesTpmWarningDataTwd.filter.twdAlarmState',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'twdAlarmStartTimeRteFilter',
        label: 'label.sith.tpm.sithMesTpmWarningDataTwd.filter.twdAlarmStartTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'twdAlarmStartTimeLteFilter',
        label: 'label.sith.tpm.sithMesTpmWarningDataTwd.filter.twdAlarmStartTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'twdAlarmEndTimeRteFilter',
        label: 'label.sith.tpm.sithMesTpmWarningDataTwd.filter.twdAlarmEndTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'twdAlarmEndTimeLteFilter',
        label: 'label.sith.tpm.sithMesTpmWarningDataTwd.filter.twdAlarmEndTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'twdAlarmDurationFilter',
        label: 'label.sith.tpm.sithMesTpmWarningDataTwd.filter.twdAlarmDuration',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'twdApplicationTypeFilter',
        label: 'label.sith.tpm.sithMesTpmWarningDataTwd.filter.twdApplicationType',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'twdClientIdFilter',
        label: 'label.sith.tpm.sithMesTpmWarningDataTwd.filter.twdClientId',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'twdOwnerIdFilter',
        label: 'label.sith.tpm.sithMesTpmWarningDataTwd.filter.twdOwnerId',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    }
];


const entityFormConfigs = [
    {
        key: 'twdAlarmDataCategory',
        label: 'label.sith.tpm.sithMesTpmWarningDataTwd.entity.twdAlarmDataCategory',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'twdAlarmDataClearInfo',
        label: 'label.sith.tpm.sithMesTpmWarningDataTwd.entity.twdAlarmDataClearInfo',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'twdAlarmDataInstance',
        label: 'label.sith.tpm.sithMesTpmWarningDataTwd.entity.twdAlarmDataInstance',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'twdAlarmDataPriority',
        label: 'label.sith.tpm.sithMesTpmWarningDataTwd.entity.twdAlarmDataPriority',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'twdAlarmDataSource',
        label: 'label.sith.tpm.sithMesTpmWarningDataTwd.entity.twdAlarmDataSource',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'twdAlarmDataState',
        label: 'label.sith.tpm.sithMesTpmWarningDataTwd.entity.twdAlarmDataState',
        sortable: true,
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'twdAlarmId',
        label: 'label.sith.tpm.sithMesTpmWarningDataTwd.entity.twdAlarmId',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'twdAlarmMessage',
        label: 'label.sith.tpm.sithMesTpmWarningDataTwd.entity.twdAlarmMessage',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'twdAlarmState',
        label: 'label.sith.tpm.sithMesTpmWarningDataTwd.entity.twdAlarmState',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'twdAlarmStartTime',
        label: 'label.sith.tpm.sithMesTpmWarningDataTwd.entity.twdAlarmStartTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'twdAlarmEndTime',
        label: 'label.sith.tpm.sithMesTpmWarningDataTwd.entity.twdAlarmEndTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'twdAlarmDuration',
        label: 'label.sith.tpm.sithMesTpmWarningDataTwd.entity.twdAlarmDuration',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'twdApplicationType',
        label: 'label.sith.tpm.sithMesTpmWarningDataTwd.entity.twdApplicationType',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'twdClientId',
        label: 'label.sith.tpm.sithMesTpmWarningDataTwd.entity.twdClientId',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'twdOwnerId',
        label: 'label.sith.tpm.sithMesTpmWarningDataTwd.entity.twdOwnerId',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'remark',
        label: 'label.sith.tpm.sithMesTpmWarningDataTwd.entity.remark',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    }
]

export {
    SithMesTpmWarningDataTwd, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs


}
